import { inject, observer } from 'mobx-react';
import React, { useState, useCallback } from 'react';
import { SongGrid } from './song-grid';
import MusicPlayer from 'common/components/music-player/player';
import { toast } from 'react-toastify';

export const SubmissionForm = ({artist, artistStore, songsStore, playlistStore, onComplete, onCancel}) => {
    const songList = songsStore.getSongsByArtistID(artist._id);
    const [currentSong, setCurrentSong] = useState(null);
    return (
        <div className='padding-left-1'>
            <h4>Viewing Artist: {artist.name}</h4>
            <div className='grid-x'>
                <button className="button neo margin-right-2" onClick={() => {onComplete(artist); toast.success(`Review of ${artist.name} complete.`);}}>Complete</button>
                <button className="button neo" onClick={onCancel}>Back</button>
            </div>

            <SongGrid dataSource={songList} onRowClick={(rowData) => {
                playlistStore.setCurrentPlaylist({list: [rowData], name: '', imagePath:''});
            }} />
            <MusicPlayer/>
        </div>
    )
}

const injectWithStores = inject('artistStore', 'songsStore', 'playlistStore');
export default injectWithStores(
    ({artist, artistStore, songsStore, playlistStore, onComplete, onCancel}) => {
        return (
            <SubmissionForm artist={artist} artistStore={artistStore} songsStore={songsStore} playlistStore={playlistStore} onComplete={onComplete} onCancel={onCancel} />
        )
})

